import * as React from "react";
import Container from "@mui/material/Container";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import useStyles from "./styles";

const SiteFooter = () => {
  const classes = useStyles(); // Using makeStyles hook
  return (
    <Paper component="footer" square variant="outlined">
      <Container maxWidth="lg">
        <Box className={classes.footer}>
          <Typography variant="body1" color="initial">
            ©2023 Dacris Software Inc. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Paper>
  );
};

export default SiteFooter;
